// extracted by mini-css-extract-plugin
export default {"Checkbox":"qd2OBg2Ga6","Checkbox_error":"_tRke77aIN"};